module.exports = __webpack_public_path__ + "img/messageDialog.3981db24.png";